import { fetchCsatSurveys } from './CsatSurveyService';
import { useEffect, useState } from 'react';
import { Survey } from '../models/Survey';
import { pssSurveys } from './PssService';
import { flatten } from 'lodash';
import { clientPackets } from './ClientPackage';
import { compareAsc } from 'date-fns';

type SurveyStatus = 'loading' | 'error' | Survey[];
export const useSurveyLoader = () => {
  const [surveys, setSurveys] = useState<SurveyStatus>('loading');
  useEffect(() => {
    Promise.all<Survey[]>([
      fetchCsatSurveys(),
      pssSurveys(false),
      clientPackets(false),
    ])
      .then((results) => flatten(results))
      .then((surveys) => surveys.sort(sortByExpiredDateFn))
      .then((fetchedSurveys) => setSurveys(fetchedSurveys))
      .catch(() => setSurveys('error'));
  }, []);

  console.log(surveys);
  return surveys;
};

const sortByExpiredDateFn = (survey1: Survey, survey2: Survey) => {
  if (survey1.expirationDate == null) {
    return 1;
  }
  if (survey2.expirationDate == null) {
    return -1;
  }
  return compareAsc(survey1.expirationDate, survey2.expirationDate);
};
